module.exports = __webpack_public_path__ + "static/media/vegetarianos.ebcb33b9.svg";